import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ImportData } from 'src/app/models/UserInfo';
import { UserService } from 'src/app/service/user.service';
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit{
  public currentUser!: ImportData;

  constructor(private router: Router, private userService: UserService,) { }

  ngOnInit(){
    this.userService.currentUser$.subscribe((result) => {
      if (result.Username) {
        this.currentUser = result;
      }
    })
  }

  public goToAdminCenter(): void {
    this.router.navigate(['/admin']);
  }

  public landingPage(): void {
    this.router.navigate(['/']);
  }
}
